<template>
  <v-footer dark class="bg-footer">
    <v-container>
      <v-row justify="center" align="center" justify-md="center">
        <!--Logo-->
        <v-col cols="12" sm="12" md="12" lg="4" class="text-center">
          <figure class="logo-footer">
            <img src="@/assets/logo_small.svg" alt="PérezBrown" />
          </figure>
        </v-col>
        <!--menu-->
        <v-col cols="12" sm="12" md="4" lg="2" class="text-center text-md-left text-lg-left">
          <v-list dense color="transparent" class="menu-footer">
            <v-list-item link to="/es/services">
              <v-list-item-content>
                <v-list-item-title>Servicios</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link to="/es/us">
              <v-list-item-content>
                <v-list-item-title>Quienes somos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link to="/es/blog">
              <v-list-item-content>
                <v-list-item-title>Blog</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link to="/es/contact">
              <v-list-item-content>
                <v-list-item-title>Contacto</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <!--extras-->
        <v-col cols="12" sm="12" md="8" lg="6" class="text-left">
          <v-row justify="center" align="center" justify-md="center">
            <v-col cols="12">
              <!--newsletter-->
              <v-row justify="space-between" align="center" justify-md="space-between">
                <v-col cols="12" sm="4" md="4" lg="4" class="text-center text-md-left text-lg-left">
                  <p class="subscribe pl-5">
                    Suscríbete
                    <br />a nuestro newsletter
                  </p>
                </v-col>
                <v-col
                  cols="12"
                  sm="8"
                  md="8"
                  lg="8"
                  class="text-center text-md-right text-lg-right"
                >
                  <!--form-->
                  <v-form ref="newsletter" v-model="formValidSubs">
                    <v-row justify="end">
                      <v-col cols="12" sm="7" md="8" lg="8" class="ma-0 pa-0">
                        <v-text-field
                          dense
                          v-model="form.email"
                          :rules="formRules.email"
                          label="Correo electrónico"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="5" md="3" lg="2" class="ma-0 pa-0">
                        <v-btn
                          color="#2AABF2"
                          depressed
                          tile
                          @click="subscribe()"
                          :loading="loading"
                          :disabled="loading || !formValidSubs"
                        >Enviar</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="text-center text-md-left text-lg-left" v-if="story">
              <v-btn class="ma-2" tile color="white" icon v-if="story.content.facebook !== ''" target="_blank" :href="story.content.facebook">
                <v-icon>mdi-facebook</v-icon>
              </v-btn>
              <v-btn class="ma-2" tile color="white" icon v-if="story.content.twitter !== ''" target="_blank" :href="story.content.twitter">
                <v-icon>mdi-twitter</v-icon>
              </v-btn>
              <v-btn class="ma-2" tile color="white" icon v-if="story.content.instagram !== ''" target="_blank" :href="story.content.instagram">
                <v-icon>mdi-instagram</v-icon>
              </v-btn>
              <v-btn class="ma-2" tile color="tewhiteal" icon v-if="story.content.linkedin !== ''" target="_blank" :href="story.content.linkedin">
                <v-icon>mdi-linkedin</v-icon>
              </v-btn>
              <v-list dense color="transparent" class="legal-footer">
                <v-list-item link to="/es/legal/privacy">
                  <v-list-item-content>
                    <v-list-item-title>Política de privacidad</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/es/legal/attorney">
                  <v-list-item-content>
                    <v-list-item-title>Attorney advertising</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="text-center text-md-right text-lg-right" v-if="story">
              <p class="subscribe">
                {{story.content.phone}}
                <br />{{story.content.address}}
                <br />{{story.content.floor}}
                <br />{{story.content.country}}
                <br />{{story.content.email}}
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="formError.state"
      :multi-line="true"
      :timeout="formError.timeout"
      :color="formError.color"
      :top="true"
    >
      {{ formError.msg }}
      <v-btn color="white" text @click="formError.state = false">Cerrar</v-btn>
    </v-snackbar>
  </v-footer>
</template>

<style lang="scss" scoped>
@import "./Menu.scss";
</style>

<script>
import { formValidation } from "@/libs/formValidation";
import firebase from "firebase/app";
// 1. Require the Storyblok client
import StoryblokClient from "storyblok-js-client";

// 2. Set your token
const token = "vNbkVTgCgnArqEk6TG7LQwtt";

// 3. Initialize the client with the preview token so we can access our API easily
// from your space dashboard at https://app.storyblok.com
let storyapi = new StoryblokClient({
  accessToken: token
});

export default {
  name: "Footer",
  mixins: [formValidation],
  data() {
    return {
      form: {
        EMAIL: null
      },
      loading: false,
      msg: "",
      story: {
        content: {
          body: []
        }
      }
    };
  },
  created() {
    // 4. Initialize the Storyblok Client Bridge to allow us to subscribe to events
    // from the editor itself.
    window.storyblok.init({
      accessToken: token
    });
    window.storyblok.on("change", () => {
      this.getStory("es/configuration", "draft");
    });
    window.storyblok.pingEditor(() => {
      if (window.storyblok.isInEditor()) {
        // draft will be loaded if embeded in app.storyblok.com
        this.getStory("es/configuration", "draft");
      } else {
        // published versions will be loaded outside of app.storyblok.com
        // so make sure to published your entries - otherwise this will be a 404
        this.getStory("es/configuration", "published");
      }
    });
  },
  methods: {
    getStory(slug, version) {
      storyapi
        .get("cdn/stories/" + slug, {
          version: version
        })
        .then(response => {
          this.story = response.data.story;
        })
        .catch(error => {
          console.log(error);
        });
    },
    subscribe() {
      if (this.formValid) {
        this.loading = true;
        const subscribe = firebase
          .functions()
          .httpsCallable("subscribe");

        subscribe(this.form)
          .then(() => {
            this.loading = false;
            this.alertError("success", "Suscripción exitosa");
            this.$refs.newsletter.reset();
          })
          .catch(() => {
            this.loading = false;
            this.alertError(
              "error",
              "Hubo un error, intenta nuevamente"
            );
            this.$refs.newsletter.reset();
          });
      }
    }
  }
};
</script>
